// extracted by mini-css-extract-plugin
export default {"component":"GuideList__component-X5WK"};